import React, { useState, useEffect, useContext, useRef } from 'react';
import SearchForm from './SearchForm';
import Filter from '../Filter/Filter Compact';
import Pagination from './Pagination';
import Cruisemaster from './Cruisemaster';
import SelectedFilter from '../Filter/SelectedFilter';
import DescriptionView from '../Views/DescriptionView';
import MapView from '../Views/MapView';
import PriceView from '../Views/PriceView';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { CartContext } from '../../Context/CartContext';
import { BaseDataContext } from '../../Context/BaseDataContext';
import Breakpoint from 'react-socks';
import onClickOutside from 'react-cool-onclickoutside';

function Search(props) {
  const filterRef = useRef();
  const [showFilter, setShowFilter] = useState({ show: false, setByUser: false });
  const [disableClickOutside, setDisableClickOutside] = useState(true);
  onClickOutside(
    filterRef,
    () => {
      setShowFilter({ show: false, setByUser: true });
    },
    { disabled: disableClickOutside }
  );

  const mdMedia = useMediaQuery('(min-width:768px)');
  const lgMedia = useMediaQuery('(min-width:1024px)');
  const xlMedia = useMediaQuery('(min-width:1280px)');

  const viewWrapperClass = "border-gray-300 border-2 rounded-lg mt-3 sticky";

  const [baseData, setBaseData] = useContext(BaseDataContext);
  const [cart, setCart] = useContext(CartContext);

  const [searchForm, setSearchForm] = useState({
    priorityProperty: "",
    selectedCabinId: 0,
    cabins: [{
      id: 1,
      cabintypeIds: [],
      persons: {
        adults: 2,
        seniors: 0,
        children: 0,
        juniorChildren: 0,
        infants: 0,
      }
    }],
    cruiselineIds: [],
    shipIds: [],
    regionIds: [],
    departureStoppointIds: [],
    onRouteStoppointIds: [],
    arrivalStoppointIds: [],
    cabintypeIds: [],
    roundtrip: false,
    durationMin: 0,
    durationMax: 0,
    departureMin: new Date(), // <- !! 
    departureMax: new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0),
    priceMax: 0,
    pagenumber: 1,
    pagesize: 10,
    sortby: null,
    sortdescending: false
  });
  const [searchResults, setSearchResults] = useState([]);
  // used for the api-response.
  const [pagination, setPagination] = useState({
    pagenumber: 1,
    pagesize: 10,
    totalPages: 1,
    totalCount: 0,
  })
  // Prevent from loading default search if token is supplied.
  // So it can get the searchtoken values first.
  const [loadingToken, setLoadingToken] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState({ hasError: false, message: "" });
  const [searchError, setSearchError] = useState({ hasError: false, message: "" });
  const [viewStatus, setViewStatus] = useState(0);
  const [selectedCruise, setSelectedCruise] = useState({
    masterid: null,
    packageid: null,
    date: null,
    categoryid: null,
    price: 0,
    cabins: [],
  });

  const replacer = function (key, value) {

    return value;
  }

  function hasEqualPersons(obj1, obj2) {
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);

    for (let objKey of obj1Keys) {
      if (objKey != "cabintypeId" && obj2Keys.includes(objKey)) {
        if (obj1[objKey] != obj2[objKey]) {
          return false;
        }
      }
    }

    return true;
  }
  function resetCabinIds(searchForm) {
    searchForm.cabins.map((cabin, index) => { cabin.id = (index + 1) });
  }
  function getJsonBody() {
    return JSON.stringify(
      searchForm, replacer
      //{
      //  priorityProperty: searchForm.priorityProperty,
      //  cabins: searchForm.cabins,
      //  cruiselineIds: searchForm.cruiselineIds,
      //  shipIds: searchForm.shipIds,
      //  departureMin: searchForm.departureMin,
      //  departureMax: searchForm.departureMax,
      //  cabintypeIds: searchForm.cabintypeIds,
      //  regionIds: searchForm.regionIds,
      //  departureStoppointIds: searchForm.departureStoppointIds,
      //  onRouteStoppointIds: searchForm.onRouteStoppointIds,
      //  arrivalStoppointIds: searchForm.arrivalStoppointIds,
      //  roundtrip: searchForm.roundtrip,
      //  durationMin: searchForm.durationMin,
      //  durationMax: searchForm.durationMax,
      //  priceMax: searchForm.priceMax,
      //  pagenumber: searchForm.pagenumber,
      //  pagesize: searchForm.pagesize,
      //  sortby: searchForm.sortby,
      //  sortdescending: searchForm.sortdescending
      //}
    )
  }
  function removeToken(field, value, cabinId) {
    const updatedSearchForm = { ...searchForm, [field]: value };
    switch (field) {
      case "cabinId":
        if (searchForm.cabins.length > 1) { // you must select at least one cabin.
          updatedSearchForm.cabins = updatedSearchForm.cabins.filter(item => item.id != value);
          resetCabinIds(updatedSearchForm);
          updatedSearchForm.selectedCabinId = 0;
        }
        break;
      case "cabintypeId":
        let cabinIndex = 0;
        if (cabinId && cabinId > 0) {
          cabinIndex = cabinId - 1;
        }
        updatedSearchForm.cabins[cabinIndex].cabintypeIds = updatedSearchForm.cabins[cabinIndex].cabintypeIds.filter(item => item != value);

        break;
      case "adults":
      case "seniors":
      case "children":
      case "juniorChildren":
      case "infants":
        if (value) {
          updatedSearchForm.cabins[value - 1].persons[field] = 0;
        }
        break;
      case "regionId":
      case "shipId":
      case "cruiselineId":
      case "departureStoppointId":
      case "onRouteStoppointId":
      case "arrivalStoppointId":
        let property = field + "s";
        updatedSearchForm[property] = updatedSearchForm[property].filter(item => item != value);
        break;
    }

    setSearchForm(updatedSearchForm);

  }
  function handleChange(field, value, cabinIndex) {
    const updatedSearchForm = { ...searchForm, [field]: value };
    const updatedCart = { ...cart };
    // update list-filters...
    switch (field) {
      case "selectedCabinId":
        if (value === searchForm.selectedCabinId) {
          updatedSearchForm.selectedCabinId = 0;
        }
        else {
          setDisableClickOutside(true);
        }
        if (!updatedSearchForm.selectedCabinId) {
          setDisableClickOutside(false);
        }
        break;
      case "cabinId":
        let numberOfSelectedCabins = searchForm.cabins.length;
        let highestId = searchForm.cabins[numberOfSelectedCabins - 1].id;
        if (numberOfSelectedCabins < value) {
          // add cabins...
          for (var i = 1; i <= value - numberOfSelectedCabins; i++) {
            updatedSearchForm.cabins.push(
              {
                id: highestId + i,
                cabintypeIds: [],
                persons:
                {
                  adults: 1,
                  seniors: 0,
                  children: 0,
                  juniorChildren: 0,
                  infants: 0,
                }
              });
            updatedCart.cabins.push({
              adults: 1,
            });
          }
          updatedSearchForm.selectedCabinId = numberOfSelectedCabins + 1; // set the selected cabin to the new.
        }
        else {
          // remove cabins...
          for (var i = 0; i < numberOfSelectedCabins - value; i++) {
            updatedSearchForm.cabins.pop();
            updatedCart.cabins.pop();
          }
          updatedSearchForm.selectedCabinId = 0;
        }
        break;
      case "adults":
      case "seniors":
      case "children":
      case "juniorChildren":
      case "infants":
        updatedSearchForm.cabins[cabinIndex].persons[field] = parseInt(value);
        updatedCart.cabins[cabinIndex][field] = parseInt(value);
        break;
      case "cabintypeId":
        if (!value && updatedSearchForm.cabins[cabinIndex].cabintypeIds.length > 0) {
          updatedSearchForm.cabins[cabinIndex].cabintypeIds.pop();
        }
        else
          if (!updatedSearchForm.cabins[cabinIndex].cabintypeIds.includes(value)) {
            updatedSearchForm.cabins[cabinIndex].cabintypeIds.length = 0;
            updatedSearchForm.cabins[cabinIndex].cabintypeIds.push(value);
          }

        let cabintypes = updatedSearchForm.cabins[cabinIndex].cabintypeIds.length;
        if (cabintypes > 0) {
          let id = updatedSearchForm.cabins[cabinIndex].cabintypeIds[cabintypes - 1];
          updatedCart.cabins[cabinIndex].cabintypeId = id;
          updatedCart.cabins[cabinIndex].cabintypeName = baseData.cabinprimarytypes.find(x => x.intId == id).name;
        }
        else {
          updatedCart.cabins[cabinIndex].cabintypeId = 0;
          updatedCart.cabins[cabinIndex].cabintypeName = "";
        }
        break;
      case "shipId":
      case "departureStoppointId":
      case "onRouteStoppointId":
      case "arrivalStoppointId":
      case "regionId":
      case "cruiselineId":
        let fields = field + "s";
        if (!value) { // value deleted => pop the latest...
          updatedSearchForm[fields].pop();
        }
        else if (!updatedSearchForm[fields].includes(value)) {
          updatedSearchForm[fields].push(value);
        }
        else {
          // a value provided that already exists in the list => remove...
          const i = updatedSearchForm[fields].indexOf(value);
          if (i > -1) {
            updatedSearchForm[fields].splice(i, 1);
          }
        }
        break;
      case "durationMinMax":
        switch (value) {
          case "0": //  1-2
            updatedSearchForm.durationMin = null;
            updatedSearchForm.durationMax = 2;
            break;
          case "1": //  3-5
            updatedSearchForm.durationMin = 3;
            updatedSearchForm.durationMax = 5;
            break;
          case "2": //  6-9
            updatedSearchForm.durationMin = 6;
            updatedSearchForm.durationMax = 9;
            break;
          case "3": //  10-14
            updatedSearchForm.durationMin = 10;
            updatedSearchForm.durationMax = 14;
            break;
          case "4": //  15+
            updatedSearchForm.durationMin = 15;
            updatedSearchForm.durationMax = null;
            break;
          default:
            updatedSearchForm.durationMin = null;
            updatedSearchForm.durationMax = null;
            break;
        }
        break;
    }
    setCart(updatedCart);
    setSearchForm(updatedSearchForm);
  }
  function handleClearAll() {
    const updatedSearchForm = { ...searchForm };
    updatedSearchForm.cabins.length = 1;
    updatedSearchForm.selectedCabinId = 1;
    updatedSearchForm.cruiselineIds.length = 0;
    updatedSearchForm.arrivalStoppointIds.length = 0;
    updatedSearchForm.cabintypeIds.length = 0;
    updatedSearchForm.departureStoppointIds.length = 0;
    updatedSearchForm.onRouteStoppointIds.length = 0;
    updatedSearchForm.regionIds.length = 0;
    updatedSearchForm.shipIds.length = 0;
    updatedSearchForm.departureMin = null;
    updatedSearchForm.departureMax = null;
    updatedSearchForm.durationMin = 0;
    setSearchForm(updatedSearchForm);
  }
  function getShowFilter() {
    return showFilter.show || (!showFilter.setByUser && lgMedia);
  }
  function handleFilterViewChange() {
    const show = getShowFilter();
    setDisableClickOutside(show);

    const filter = { ...showFilter };
    filter.setByUser = true;
    filter.show = !show
    setShowFilter(filter);
  }
  function handleViewChange(newStatus) {
    let status = viewStatus;
    if (newStatus) {
      status = newStatus;
    }
    else {
      status++;
      if (status > 3)
        status = 1;
    }
    setViewStatus(status);
  }
  function updateCart(cruisemasterId) {
    let updatedCart = { ...cart };
    let master = searchResults.find(x => x.id == cruisemasterId);
    updatedCart.masterId = cruisemasterId;
    updatedCart.name = master.name;
    updatedCart.departure = master.cheapestDeparture;
    updatedCart.duration = master.duration;
    updatedCart.ship = master.ship.name;
    updatedCart.cruiseline = master.ship.cruiseline.name;
    let cp = master.cruisePackages.find(x => x.departure == master.cheapestDeparture);
    updatedCart.packageId = cp.id;
    // the cabins in the cart is created via the filter, so this is just an update of them.
    // cabins and pricegrids is matched up and the cabins are updated with cabintype and price from the grid.
    // the problem is how to match the items from 2 arrays if the person-combination is the same in 2 cabins...
    let processedCabins = [];
    cp.priceGrids.map((grid) => {
      const cabin = updatedCart.cabins.find(x => !processedCabins.includes(x) && hasEqualPersons(x, grid));
      if (cabin) {
        cabin.cabintypeId = grid.cabintypeId;
        cabin.cabintypeName = baseData.cabinprimarytypes.find(x => x.id === grid.cabintypeId).name;
        cabin.price = grid.lowestPrice / 100;
        processedCabins.push(cabin);
      }
    });
    setCart(updatedCart);
  }
  function handleCruiseSelection(cruisemasterId) {
    updateCart(cruisemasterId);

    if (cruisemasterId != selectedCruise.masterid) {
      // selected cruise has changed...
      const updated = { ...selectedCruise, masterid: cruisemasterId };
      setSelectedCruise(updated);
    }

    {/*
    let status = viewStatus;
    if (!selected) {
      // reset selected cruise and hide the view-panel.
      setSelectedCruise();
      setViewStatus(0);
      return;
    }

    if (selected != selectedCruise) {
      // selected cruise has changed...
      setSelectedCruise(selected);
      if (status == 0) {
        setViewStatus(3); // PriceView is default 
        if (mediaMatched.matches) {
          setShowFilter(false);
        }
      }
    }
    */}
  }
  function handleDateSelection(index, cruise) {
    updateCart(cruise.id);

    let cp = cruise.cruisePackages[index];
    const updated = { ...selectedCruise, date: new Date(cp.departure) };
    updated.masterid = cruise.id;
    setSelectedCruise(updated);
  }

  useEffect(() => {
    setLoading(true);
    if (props.match.params.token != null) // from the url
    {
      fetch("/api/proxy/translatetoken?tokenstring=" + encodeURIComponent(props.match.params.token))
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then((result) => {
          setSearchError({ hasError: false, message: "" });
          // result.token can not be added directly, since dates need to be converted to real JS Date.
          // Real dates is requried by 'react-datepicker'.
          const updatedSearchForm = { ...searchForm };
          updatedSearchForm.cabins = result.cabins;
          updatedSearchForm.cruiselineIds = result.cruiselineIds;
          updatedSearchForm.shipIds = result.shipIds;
          updatedSearchForm.regionIds = result.regionIds;
          updatedSearchForm.departureStoppointIds = result.departureStoppointIds;
          updatedSearchForm.onRouteStoppointIds = result.onRouteStoppointIds;
          updatedSearchForm.arrivalStoppointIds = result.arrivalStoppointIds;
          updatedSearchForm.roundtrip = result.roundtrip;
          updatedSearchForm.durationMin = result.durationMin;
          updatedSearchForm.durationMax = result.durationMax;
          updatedSearchForm.priceMax = result.priceMax;
          updatedSearchForm.pagenumber = result.pagenumber;
          updatedSearchForm.pagesize = result.pagesize;

          updatedSearchForm.departureMin = result.departureMin ? new Date(result.departureMin) : null;
          updatedSearchForm.departureMax = result.departureMax ? new Date(result.departureMax) : null;

          //updatedSearchForm.sortby = result.sortby;
          //updatedSearchForm.sortdescending = result.sortdescending;
          setSearchForm(updatedSearchForm);

          const updatedCart = { ...cart };
          updatedCart.cabins.length = 0;
          result.cabins.map((cab) => {
            let cabintypeId = 0;
            if (cab.cabintypeIds.length > 0) {
              cabintypeId = cab.cabintypeIds[0];
            }

            updatedCart.cabins.push(
              {
                cabintypeId: cabintypeId,
                adults: cab.persons.adults,
                seniors: cab.persons.seniors,
                children: cab.persons.children,
                juniorChildren: cab.persons.juniorChildren,
                infants: cab.persons.infants,
              });
          });
          setCart(updatedCart);
          setLoadingToken(false);
        })
        .catch(err => {
          setSearchError({ hasError: true, message: err.message });
        })
    }
    else {
      // No token, so load default search.
      setLoadingToken(false);
    }
    setLoading(false);
  }, []);
  useEffect(() => {
    if (!loadingToken) {
      var searchurl = '/api/proxy/search/';

      fetch(searchurl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: getJsonBody()
      })
        .then(response => {
          if (!response.ok) {
            throw Error("**** Error status " + response.status + " " + response.statusText + " ****");
          }
          return response.json();
        })
        .then((result) => {
          setSearchError({ hasError: false, message: "" });

          setSearchResults(result.result.list);
          setPagination(result.result.pagination);
          //setDebug(JSON.stringify(result.result.list))
          props.history.push("/search/" + result.token);
        })
        .catch(err => {
          setSearchError({ hasError: true, message: err.message });
        })

      let method = 'GET';
      let headers = {};
      let body = "";
      if (props.match.params.token != null) {
        method = 'POST';
        headers = { 'Content-Type': 'application/json' };
        body = getJsonBody();
      }
      fetch("/api/proxy/basedata", {
        method: method,
        headers: headers,
        body: body,
      })
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then((result) => {
          setSearchError({ hasError: false, message: "" });

          const updatedSetSearchFormArrays = { ...baseData };
          updatedSetSearchFormArrays.issues = result.result.issues;
          updatedSetSearchFormArrays.cruiselines = result.result.cruiselines;
          updatedSetSearchFormArrays.ships = result.result.ships;
          updatedSetSearchFormArrays.cabinprimarytypes = result.result.cabinprimarytypes;
          updatedSetSearchFormArrays.regions = result.result.regions;
          updatedSetSearchFormArrays.stoppoints = result.result.stoppoints;
          updatedSetSearchFormArrays.sortbyList = result.result.sortbyList;
          updatedSetSearchFormArrays.pictureserver = result.result.pictureserver;
          setBaseData(updatedSetSearchFormArrays);

          const updatedCart = { ...cart };
          updatedCart.cabins.map((cab) => {
            const cabintype = result.result.cabinprimarytypes.find(x => x.intId == cab.cabintypeId);
            if (cabintype) {
              cab.cabintypeName = cabintype.name;
            }
          });
          setCart(updatedCart);
          setLoading(false);
        })
        .catch(err => {
          setSearchError({ hasError: true, message: err.message });
          setLoading(false);
        })

    }
  }, [searchForm, loadingToken]);
  useEffect(() => {
    if (!loadingToken) {
      props.history.push({
        pathname: "/details/" + props.match.params.token + "/" + selectedCruise.masterid,
      });
    }
  }, [selectedCruise]);

  if (loading) {
    return (
      <React.Fragment>
        Loading...
      </React.Fragment >
    );
  }
  else {
    return (
      <React.Fragment>
        {searchError.hasError && <div className="py-3 text-center bg-red-200 text-red-700 text-base">{searchError.message}</div>}
        <Breakpoint xs up className="sticky top-0 z-40">
          <div className="relative z-20" style={{ boxShadow: '0px 10px 10px rgba(0,0,0,0.16)' }}>
            <SearchForm
              wrapperClass="flex flex-col sm:flex-row bg-cruise_darkblue py-2 px-4 searchform"
              searchForm={searchForm}
              handleChange={handleChange}
              handleSubmit={handleClearAll}
              clearAllMode
              calendarPopsDown={true}
            />
          </div>
          <div className="relative z-10 bg-cruise_background flex items-center justify-between px-8 pt-4 ">
            <div className="flex items-center px-4 cursor-pointer"
              onClick={handleFilterViewChange}>
              <span className="pr-2 uppercase">filters</span>
              <svg className="inline fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <title>Filtermenu</title>
                {getShowFilter()
                  ? <path d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                  : <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                }
              </svg>
            </div>
            {/*
               <span
                className="p-1 text-cruise_orange">
                {disableClickOutside ? "filter onClickOutside is disabled" : "filter onClickOutside is enabled"}
              </span>
              <SelectedFilter
                searchForm={searchForm}
                searchFormArrays={baseData}
                handleClick={removeToken} />
                */}
            <Pagination
              pagenumber={pagination.pagenumber}
              pagesize={pagination.pagesize}
              totalPages={pagination.totalPages}
              totalCount={pagination.totalCount}
              sortbyList={baseData.sortbyList}
              sortby={searchForm.sortby}
              sortdescending={searchForm.sortdescending}
              ellipsis={lgMedia} maxButtons={lgMedia ? 3 : 1} size={lgMedia ? 'lg' : 'sm'}
              next prev boundaryLinks={true}
              onPageChange={(e) => { handleChange("pagenumber", e) }}
              onPagesizeChange={(e) => { handleChange("pagesize", e) }}
              onSortByChange={(e) => { handleChange("sortby", e) }}
              onSortDescendingChange={handleChange}
            />
          </div>
        </Breakpoint>
        <div className="flex flex-1 flex-row bg-cruise_background z-10 px-8">
          <div className="z-20">
            {
              getShowFilter()
                ? <React.Fragment>
                  <div ref={!lgMedia ? filterRef : null}
                    className={lgMedia ? "" : "absolute z-40 overflow-auto "}>
                    <Filter
                      wrapperClass="p-0 rounded "
                      searchForm={searchForm}
                      searchFormArrays={baseData}
                      handleChange={handleChange}
                      dropdownOpen={setDisableClickOutside}
                    />
                  </div>
                </React.Fragment>
                : null
            }
          </div>
          <div className="flex flex-1 flex-row ">
            {searchResults.length > 0
              ?
              <React.Fragment>
                <main className="flex flex-1 flex-wrap lg:flex-col pl-5 justify-around" >
                  {searchResults.map((cruisemaster) =>
                    <Cruisemaster token={props.match.params.token}
                      key={cruisemaster.id}
                      wrapperClass="w-full pb-3 sm:w-5/12 lg:w-full "
                      pictureserver={baseData.pictureserver}
                      cruisemaster={cruisemaster} match={props.match}
                      cabinprimarytypes={baseData.cabinprimarytypes}
                      selectedClass={cruisemaster == selectedCruise ? "border-blue-400 border-2 rounded" : ""}
                      handleSelection={() => handleCruiseSelection(cruisemaster.id)}
                      handleDateSelection={(e) => { handleDateSelection(e, cruisemaster) }}
                    />
                  )}
                </main>
                {
                  viewStatus == 1
                    ?
                    <aside className="max-w-xl">
                      <DescriptionView
                        wrapperClass={viewWrapperClass}
                        selectedCruise={selectedCruise}
                        pictureserver={baseData.pictureserver}
                        handlePriceViewChange={() => { handleViewChange(3) }}
                        handleMapViewChange={() => { handleViewChange(2) }}
                        token={props.match.params.token} />
                    </aside>
                    : viewStatus == 2
                      ?
                      <aside>
                        <MapView
                          wrapperClass={viewWrapperClass}
                          selectedCruise={selectedCruise}
                          pictureserver={baseData.pictureserver}
                          handleDescriptionViewChange={() => { handleViewChange(1) }}
                          handlePriceViewChange={() => { handleViewChange(3) }}
                          token={props.match.params.token}
                        />
                      </aside>
                      : viewStatus == 3
                        ?
                        <aside>
                          <PriceView
                            wrapperClass={viewWrapperClass}
                            selectedCruise={selectedCruise}
                            pictureserver={baseData.pictureserver}
                            cabinprimarytypes={baseData.cabinprimarytypeIds}
                            handleDescriptionViewChange={() => { handleViewChange(1) }}
                            handleMapViewChange={() => { handleViewChange(2) }}
                          />
                        </aside>
                        : null
                }
              </React.Fragment>
              :
              <div className="flex flex-1 align-items-center justify-center h-full">
                <div className="text-center">
                  <h5>No results were found :(</h5>
                  <p>Please, change seach criteria and try again.</p>
                  {baseData.issues.length > 0 &&
                    <div className="m-4 p-4 bg-red-300 text-red-800 text-center text-base rounded-lg">
                      <legend>Filter conflict detected</legend>
                      {baseData.issues.map((issue, index) =>
                        <p key={index}>{issue}</p>)}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Search;